import React from "react";
import classNames from "classnames";
import { Form } from "rsuite";
import styles from "./orderForm.module.scss";

type FormSectionProps = {
  title: string;
  visuallyHiddenTitle?: boolean;
  className?: string;
  controlId?: string;
  children: React.ReactNode;
};

const FormSection: React.FC<FormSectionProps> = ({
  title,
  visuallyHiddenTitle = false,
  className,
  controlId,
  children,
}) => (
  <Form.Group controlId={controlId} className={classNames(styles.formSection, className)}>
    <Form.ControlLabel
      className={classNames(styles.formSectionTitle, {
        [styles.formSectionTitleHidden]: visuallyHiddenTitle,
      })}
    >
      {title}
    </Form.ControlLabel>
    {children}
  </Form.Group>
);

export default FormSection;
